<template>
  <div class="Model">
    <Modal
      v-model="cancleStatus"
      :title="title"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
      
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="任务参数" prop="executorParam">
          <Input v-model="formValidate.executorParam" type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入任务参数"></Input>
        </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="cancel('formValidate')" style="width: 100px; margin-right: 20px">取消</Button>
      <Button class="ys-confirm" type="primary" @click="ok('formValidate')" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props:{
    cancleStatus: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '执行一次'
    }
  },
  data() {
    return {
      formValidate: {
        executorParam: ''
      },
      ruleValidate: {
        executorParam: [
           { required: true, message: '请输入任务参数', trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    ok (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('handle-cancle-model', {code: 1, executorParam: this.formValidate.executorParam});
          this.$refs[name].resetFields();
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    cancel (name) {
      this.$refs[name].resetFields();
      this.$emit('handle-cancle-model', {code: 2})
    }
  },
  mounted() {
    
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>